export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLAN_SUCCESS  = "GET_PLAN_SUCCESS";
export const GET_REQUEST_SUCCESS  = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR    = "GET_REQUEST_ERROR";
